import { createTheme, ThemeOptions } from '@mui/material';
import { deepmerge } from 'deepmerge-ts';

export function getNewMuiTheme(theme: ThemeOptions = {}) {
  const tempTheme = createTheme({ ...theme });
  const componentsOverride: ThemeOptions = {
    components: {
      // MuiDataGrid: {
      //   styleOverrides: {
      //     columnHeaders: {
      //       fontWeight: 700,
      //     },
      //     columnHeader: {
      //       // fontSize: tempTheme.typography.h6.fontSize,
      //       fontWeight: 700,
      //     },
      //   },
      // },
      MuiAlert: {
        defaultProps: {
          variant: 'filled',
          icon: false,
        },
        styleOverrides: {
          root: ({ ownerState }) => ({
            fontWeight: 'bold',
            color: 'black',
            ...(ownerState.severity === 'success' && {
              backgroundColor: tempTheme.palette.success.light,
            }),
            ...(ownerState.severity === 'error' && {
              backgroundColor: tempTheme.palette.error.light,
            }),
          }),
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              fontWeight: 'bold',
            },
            fontWeight: 'normal',
            color: tempTheme.palette.text.primary,
            borderBottom: `2px solid ${tempTheme.palette.divider}`,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            padding: tempTheme.spacing(2, 3),
            borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
      MuiList: {
        styleOverrides: {
          root: {
            padding: 0,
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          },
        },
      },
      MuiChip: {
        defaultProps: {
          size: 'small',
          variant: 'filled',
        },
        styleOverrides: {
          root: {
            margin: 0,
            fontWeight: '400',
          },
        },
      },
      // MuiSelect: {
      //   styleOverrides: {
      //     icon: {
      //       marginRight: tempTheme.spacing(2),
      //     },
      //   },
      // },

      MuiButton: {
        defaultProps: {
          disableElevation: true,
          // disableRipple: true,
        },
        styleOverrides: {
          root: {
            // borderRadius: 6,
            '&:active': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            // marginTop: tempTheme.spacing(1),
            // marginBottom: tempTheme.spacing(1),
            fontSize: '14px',
            lineHeight: '28px',
            fontWeight: 700,
            color: tempTheme.palette.text.primary,
          },
        },
      },
      MuiToggleButton: {
        styleOverrides: {
          root: {
            borderColor: tempTheme.palette.primary.main,
            fontWeight: 400,
            '&.Mui-selected': {
              color: tempTheme.palette.primary.main,
              fontWeight: 700,
            },
            color: tempTheme.palette.text.primary,
            padding: tempTheme.spacing(1, 3),
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            borderColor: tempTheme.palette.divider,
            // height: '44px',
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          elevation: 0,
        },
        styleOverrides: {
          root: {
            boxShadow: 'none',
            // borderRadius: 6,
          },
        },
      },
    },

    typography: {
      h1: {
        fontSize: '1.5rem', // 24px converted to rem
        fontStyle: 'normal',
        fontWeight: 400,
      },
      h2: {
        fontSize: '1.25rem', // 20px converted to rem
        fontStyle: 'normal',
        fontWeight: 400,
      },
      h3: {
        fontSize: '1.125rem', // 18px converted to rem
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h4: {
        fontSize: '1rem', // 16px converted to rem
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h5: {
        fontSize: '0.875rem', // 14px converted to rem
        fontStyle: 'normal',
        fontWeight: 700,
      },
      h6: {
        fontSize: '0.75rem', // 12px converted to rem
        fontStyle: 'normal',
        fontWeight: 700,
      },
      body1: {
        fontSize: '1rem', // 16px converted to rem
        fontStyle: 'normal',
        fontWeight: 400,
      },
      body2: {
        fontSize: '0.875rem', // 14px converted to rem
        fontStyle: 'normal',
        fontWeight: 400,
      },
      subtitle1: {
        fontSize: '0.875rem', // 14px converted to rem
        fontStyle: 'normal',
        fontWeight: 600,
      },
      subtitle2: {
        fontSize: '0.75rem', // 12px converted to rem
        fontStyle: 'normal',
        fontWeight: 600,
      },
      caption: {
        fontSize: '0.625rem', // 10px converted to rem
        fontStyle: 'normal',
        fontWeight: 400,
      },
    },
  };
  return createTheme(deepmerge(theme, componentsOverride));
}
